(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["text"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const modal = document.querySelector('[data-modal-detail]');
    const triggers = document.querySelectorAll('[data-modal-open-detail]');
    const closeBtn = document.querySelector('[data-modal-close-detail]');
    const overlay = document.querySelector('[data-modal-overlay-detail]');
    
    if (triggers.length > 0 && modal) {
      // Open modal function
      function openModal() {
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
        modal.setAttribute('aria-hidden', 'false');
      }
      
      // Close modal function
      function closeModal() {
        modal.classList.remove('active');
        document.body.style.overflow = '';
        modal.setAttribute('aria-hidden', 'true');
      }
      
      // Add click event to all triggers
      triggers.forEach(trigger => {
        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          openModal();
        });
      });
      
      // Close on X button
      if (closeBtn) {
        closeBtn.addEventListener('click', closeModal);
      }
      
      // Close on overlay click
      if (overlay) {
        overlay.addEventListener('click', closeModal);
      }
      
      // Close on ESC key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal.classList.contains('active')) {
          closeModal();
        }
      });
      
      // Prevent modal content clicks from closing
      const modalContainer = document.querySelector('.modal-container-detail');
      if (modalContainer) {
        modalContainer.addEventListener('click', function(e) {
          e.stopPropagation();
        });
      }
    }
  });
  } catch(e) { console.error(e); }
})();

})();
